import * as React from 'react'

import { Box, Button, Text } from '@factorialco/deprecated-design-system'
import { ProcurementFile } from 'generated/resources/graphql'

import DocumentType from 'modules/core/components/DocumentType'
import buildUrl from 'modules/core/lib/buildUrl'

interface DropItemProps {
  file: ProcurementFile
  onRemove?: (fileId: number) => void
  onDownload?: (fileId: number) => void
}

const DropItem = ({ file, onRemove, onDownload }: DropItemProps) => {
  const [isHovered, setIsHovered] = React.useState(false)

  const background = isHovered ? 'grey100' : 'grey000White'
  const fileUrl = buildUrl(file.url)

  return (
    <Box
      flexDirection="row"
      justifyContent="spaceBetween"
      alignItems="center"
      height="s64"
      padding="s8"
      borderRadius={{ all: 'abs008' }}
      border={{
        all: {
          width: 's1',
          style: 'solid',
          color: 'grey400',
        },
      }}
      background={background}
      gap="s8"
      cursor="pointer"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Box flexDirection="row" gap="s12">
        <Box justifyContent="center">
          <DocumentType mimetype={file.contentType} />
        </Box>
        <Box justifyContent="center">
          <Box
            flexDirection="column"
            justifyContent="flexStart"
            alignItems="flexStart"
            gap="s4"
            maxWidth="s240"
          >
            <Text.Normal ellipsis weight="semibold" size="200">
              {file.filename}
            </Text.Normal>
          </Box>
        </Box>
      </Box>
      <Box flexDirection="row" gap="s8">
        <Button.Router
          type="secondary"
          title={file.filename}
          to={fileUrl}
          rel="noopener noreferrer"
          download
          blankTarget
          iconName="download"
          onClick={() => onDownload?.(file.id)}
        />
        {onRemove && (
          <Button
            type="secondary"
            iconName="delete"
            title="Delete"
            onClick={() => onRemove?.(file.id)}
          />
        )}
      </Box>
    </Box>
  )
}

export default DropItem
